//
//
//
//

export default {
    computed: {
        url () {
            return `/building/sunlight?building_id=${this.building_id}&title=${this.title}`
        },
        show () {
            return this.activities.indexOf('sunlight') > -1
        }
    },
    props: {
        title: {
            type: String
        },
        building_id: {
            type: [String, Number]
        },
        activities: {
            type: Array,
            default: () => ([])
        }
    }
}
